class FavouriteTransaction {
  id: number;
  appTransactionId: number;
  appTransactionUniqueId: number;
  description: string;
  appTransactionDescription: string;
  status: string;
  enabled: boolean;
  scheduledDate: string;
  createdDate: string;
  lastUpdatedDate: string;
  alias?: string;
  fromAccount?: string;
  toAccount?: string;
  details?: string;
  amount?: number;
  currency?: string;

  constructor(
    id: number,
    appTransactionId: number,
    appTransactionUniqueId: number,
    description: string,
    appTransactionDescription: string,
    status: string,
    enabled: boolean,
    scheduledDate: string,
    createdDate: string,
    lastUpdatedDate: string,
    alias?: string,
    fromAccount?: string,
    toAccount?: string,
    details?: string,
    amount?: number,
    currency?: string,
  ) {
    this.id = id;
    this.appTransactionId = appTransactionId;
    this.appTransactionUniqueId = appTransactionUniqueId;
    this.description = description;
    this.appTransactionDescription = appTransactionDescription;
    this.status = status;
    this.enabled = enabled;
    this.scheduledDate = scheduledDate;
    this.createdDate = createdDate;
    this.lastUpdatedDate = lastUpdatedDate;
    this.alias = alias;
    this.fromAccount = fromAccount;
    this.toAccount = toAccount;
    this.details = details;
    this.amount = amount;
    this.currency = currency;
  }
}

export { FavouriteTransaction };
